import {createContext, useContext, useMemo} from 'react'

import type {BrandPageWithIds} from '../../lib/types/contentful/contentTypes/brand-page'

const PageContext = createContext<BrandPageWithIds | undefined>(undefined)

type Props = {
  children: React.ReactNode
  page: BrandPageWithIds
}

export function PageProvider(props: Props) {
  const {children, page} = props
  const value = useMemo(() => page, [page])

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>
}

export function usePage(): BrandPageWithIds {
  const context = useContext(PageContext)

  if (!context) {
    throw new Error('usePage must be used within a PageProvider')
  }

  return context
}

try{ PageContext.displayName ||= 'PageContext' } catch {}
try{ PageProvider.displayName ||= 'PageProvider' } catch {}